import { makeStyles } from "@material-ui/core";
import { h3, h5Medium, h6Regular, h6Medium } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

// Passed to PhoneInput's `style` prop rather than used as a JSS class,
// matching how the underlying (untyped) third-party component expects it.
export const phoneInputStyle = {
  ...h6Regular,
  direction: "ltr" as const,
  width: 360,
};

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    background: "#FFFFFF",
    borderRadius: 16,
    padding: 40,
  },
  title: {
    ...h3,
    marginBottom: 40,
  },
  nameRow: {
    display: "flex",
    marginBottom: 32,
  },
  phoneTitle: {
    ...h5Medium,
    opacity: 0.8,
    marginBottom: 16,
  },
  phoneRow: {
    display: "flex",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actionLink: {
    ...h6Medium,
    ...pointer,
    color: "lightgray",
    paddingLeft: 12,
  },
  actionLinkActive: {
    color: "#80BB34",
  },
}));
